import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid,Box } from '@material-ui/core';
// import './flight.css'
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedFormData, setSelectSeat } from '../../reducers/UiReducer';
import { useLocation } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenSeatTripJack({item}) {
  const [open, setOpen] = React.useState(false);
  const {ssrTBO} = useSelector((state)=>state.home)
  const [selectedSeat, setSelectedSeat] = useState({});
  const { farequotetripjack,ssrtripjack} = useSelector((state) => state.tripjack);
  const location = useLocation();
  const dispatch = useDispatch();
  const [condition, setCondition] = useState(false);
	const [seat, setSeat] = useState();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleChange = (e) => {
		let { name, checked, type } = e.target;
		console.log('name', name);
		console.log('checked', checked);
		console.log('type', type);
		setSelectedSeat({
      ...selectedSeat,
      [name]: (type = 'checkbox' ? checked : ''),
    });
	};
  let selectSeat = [];
  
	if (seat && seat.length > 0 && ssrtripjack) {
		ssrtripjack&&ssrtripjack.result&&ssrtripjack.result.tripSeatMap&&ssrtripjack.result.tripSeatMap.tripSeat[item.id]?.sInfo.map((i) => {
     
        seat.map((it)=>{
          if(it===i.code){
            selectSeat.push({
              ...i
            })
          }
        })
			});
	}
	console.log('seatz', seat);
	console.log('selectSeat', selectSeat);
  const handleClose = () => {
    setOpen(false);
    // dispatch(setSelectedFormData(formData))
  };
  useEffect(() => {
		for (let x in selectedSeat) {
			if (selectedSeat[x] === false) {
				setCondition(false);
				continue;
			} else {
				setCondition(true);
				break;
			}
		}

		const a = [];
		for (let y in selectedSeat) {
      console.log("y",y)
			if (selectedSeat[y] == false) {
				continue;
			} else {
				a.push(y);
			}
		}
    
		setSeat(a);
    dispatch(setSelectSeat(a))
	}, [selectedSeat]);
  let row1=[];
  let row2=[];
  let row3=[];
  let row4=[];
  let row5=[];
  let row6=[];
  let row7=[];
  let row8=[];
  let row9=[];
  let row10=[];
  let row11=[];
  let row12=[];
  let row13=[];
  let row14=[];
  let row15=[];
  let row16=[];
  let row17=[];
  let row18=[];
  let row19=[];
  let row20=[];
  let row21=[];
  let row22=[];
  let row23=[];
  let row24=[];
  let row25=[];
  let row26=[];
  let row27=[];
  let row28=[];
  let row29=[];
  let row30=[];
  let seatTrip=[];
  if(ssrtripjack){
    // console.log("ds",ssrtripjack&&ssrtripjack.result&&ssrtripjack.result.tripSeatMap&&ssrtripjack.result.tripSeatMap.tripSeat['939'].sInfo)
    ssrtripjack&&ssrtripjack.result&&ssrtripjack.result.tripSeatMap&&ssrtripjack.result.tripSeatMap.tripSeat[item.id]?.sInfo.map((i,index)=>
    {
      if(i.seatPosition.row===1){
        row1.push({
          ...i
        })
      }
      if(i.seatPosition.row===2){
        row2.push({
          ...i
        })
      }
      if(i.seatPosition.row===3){
        row3.push({
          ...i
        })
      }
      if(i.seatPosition.row===4){
        row4.push({
          ...i
        })
      }
      if(i.seatPosition.row===5){
        row5.push({
          ...i
        })
      }
      if(i.seatPosition.row===6){
        row6.push({
          ...i
        })
      }
      if(i.seatPosition.row===7){
        row7.push({
          ...i
        })
      }
      if(i.seatPosition.row===8){
        row8.push({
          ...i
        })
      }
      if(i.seatPosition.row===9){
        row9.push({
          ...i
        })
      }
      if(i.seatPosition.row===10){
        row10.push({
          ...i
        })
      }
      if(i.seatPosition.row===11){
        row11.push({
          ...i
        })
      }
      if(i.seatPosition.row===12){
        row12.push({
          ...i
        })
      }
      if(i.seatPosition.row===13){
        row13.push({
          ...i
        })
      }
      if(i.seatPosition.row===14){
        row14.push({
          ...i
        })
      }
      if(i.seatPosition.row===15){
        row15.push({
          ...i
        })
      }
      if(i.seatPosition.row===16){
        row16.push({
          ...i
        })
      }
      if(i.seatPosition.row===17){
        row17.push({
          ...i
        })
      }
      if(i.seatPosition.row===18){
        row18.push({
          ...i
        })
      }
      if(i.seatPosition.row===19){
        row19.push({
          ...i
        })
      }
      if(i.seatPosition.row===20){
        row20.push({
          ...i
        })
      }
      if(i.seatPosition.row===21){
        row21.push({
          ...i
        })
      }
      if(i.seatPosition.row===22){
        row22.push({
          ...i
        })
      }
      if(i.seatPosition.row===23){
        row23.push({
          ...i
        })
      }
      if(i.seatPosition.row===24){
        row24.push({
          ...i
        })
      }
      if(i.seatPosition.row===25){
        row25.push({
          ...i
        })
      }
      if(i.seatPosition.row===26){
        row26.push({
          ...i
        })
      }
      if(i.seatPosition.row===27){
        row27.push({
          ...i
        })
      }
      if(i.seatPosition.row===28){
        row28.push({
          ...i
        })
      }
      if(i.seatPosition.row===29){
        row29.push({
          ...i
        })
      }
      if(i.seatPosition.row===30){
        row30.push({
          ...i
        })
      }
  })
   
  }
console.log("row1",row1)
console.log("row2",row2)
console.log("row3",row3)
console.log("row4",row4)
console.log("row5",row5)
console.log("row6",row6)
console.log("row7",row7)
console.log("row8",row8)
console.log("row9",row9)
console.log("row9",row10)
console.log("row9",row11)
console.log("row9",row12)
console.log("row9",row13)
console.log("row9",row14)
console.log("row9",row15)
console.log("row9",row15)
console.log("row9",row16)
console.log("row9",row17)
console.log("row9",row18)
console.log("row9",row19)
console.log("row9",row20)
console.log("row9",row21)
console.log("row9",row22)
console.log("row9",row23)
console.log("row9",row24)
console.log("row9",row25)
console.log("row9",row26)
console.log("row9",row27)
console.log("row9",row28)
console.log("row9",row29)
console.log("row9",row30)
seatTrip=[row1,row2,row3,row4,row5,row6,row7,row8,row9,row10,row11,row12,row13,row14,row15,row16,row17,row18,row19,row20,row21,row22,row23,row24,row25,row26,row27,row28,row29,row30]
// console.log("row31",row31)
console.log("seatTrip",seatTrip)

  return (
    <div style={{boxShadow: 'rgb(0 0 0 / 15%) 0px 0.5rem 1rem',
    background: 'white',
    padding: '10px',
    marginTop: '10px'
}}>
      <Box display={'flex'} >
        <h5>{item.da.code}</h5>
        <h5 style={{marginLeft:5}}>-</h5>
        <h5 style={{marginLeft:5}}>{item.aa.code}</h5>
      </Box>
      <Button variant="outlined" onClick={handleClickOpen}>
        Select Seat
      </Button>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            <Box display={'flex'} >
        <h5>{item.da.code}</h5>
        <h5 style={{marginLeft:5}}>-</h5>
        <h5 style={{marginLeft:5}}>{item.aa.code}</h5>
      </Box>
            </Typography>
            <Button autoFocus color="inherit" onClick={handleClose}>
              Done
            </Button>
          </Toolbar>
        </AppBar>
       <Grid container style={{alignItems:'baseline'}} >
        <Grid item xs={1}></Grid>
        <Grid item xs={12} lg={3} style={{paddingLeft:20}} >
          
        </Grid>
        <Grid item xs={12} lg={8}>
        <div class="plane">
  <div class="cockpit">
    <h1>Please select a seat</h1>
  </div>
  <div class="exit exit--front fuselage">
    
  </div>
  <ol class="cabin fuselage">
    {seatTrip?.map((i,index)=>{
      return  <li class="row row--1">
      <ol class="seats" type="A">
        {
          index>0?i.map((item,index)=>{
            return <li class="seatss">
            <input type="checkbox" onChange={handleChange} name={item.code} value='fl' id={`checkbox-id${item.code}`}  disabled={item.isBooked} />
            <label for={`checkbox-id${item.code}`} title={`₹ ${item.amount}`}>{item.code}</label>
            {/* <br></br><span style={{fontSize:11}}>₹{item.amount}</span> */}
            {/* <label for={`checkbox-id${item.Code}`} >₹{item.Price}</label> */}
          </li>
          }):''
        }
      </ol>
    </li>
    })}
   
  </ol>
  <div class="exit exit--back fuselage">
    
  </div>
</div>
        </Grid>
       </Grid>
      </Dialog>
    </div>
  );
}
